"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.distanceDifference = exports.convertPointTypePathToArea = exports.covertLateralPathToAreaV2 = exports.covertLateralPathToArea = exports.convertLineTypePathToArea = void 0;
const tslib_1 = require("tslib");
const circle_1 = tslib_1.__importDefault(require("@turf/circle"));
const helpers_1 = require("@turf/helpers");
const turf_1 = require("@turf/turf");
const EffluentSpreaderHelper_1 = require("./EffluentSpreaderHelper");
const convertLineTypePathToArea = (line, throwRadius) => {
    if (throwRadius === undefined) {
        return undefined;
    }
    let boundary = EffluentSpreaderHelper_1.EffluentSpreaderHelper.getLineBoundaries(line, throwRadius);
    let pathing = boundary === null || boundary === void 0 ? void 0 : boundary.geometry.coordinates[0];
    let area = EffluentSpreaderHelper_1.EffluentSpreaderHelper.convertTurfToPosition(pathing);
    return area;
};
exports.convertLineTypePathToArea = convertLineTypePathToArea;
/**
 * @deprecated covertLateralPathToAreaV2 . Need to confirm it is the correct
 */
const covertLateralPathToArea = (line, throwRadius, radius, basis) => {
    var _a;
    if (throwRadius === undefined || radius === undefined) {
        return undefined;
    }
    if (radius === 0) {
        return (0, exports.convertLineTypePathToArea)(line, throwRadius);
    }
    let north = [line[0].lng, line[0].lat + 1];
    let start = [line[0].lng, line[0].lat];
    let end = [line[line.length - 1].lng, line[line.length - 1].lat];
    let angleDiff = (0, turf_1.angle)(north, start, end);
    // let angleLine = lineString([north, start, end])
    // if (booleanClockwise(angleLine)) {
    //   angleDiff = 360 - angleDiff;
    // }
    // same point, a horizontal lines gets created
    // if too close
    let lineDiff = (0, turf_1.distance)(start, end, { units: 'meters' });
    let isSmallType = lineDiff < throwRadius;
    if (isSmallType && basis && basis.path && basis.path.length > 0) {
        // if (lineDiff < 10 && basis && basis.path && basis.path.length > 0) {
        let extreme = EffluentSpreaderHelper_1.EffluentSpreaderHelper.convertPositionToTurf(basis.path);
        let mid = (0, turf_1.midpoint)(extreme[0], extreme[1]).geometry.coordinates;
        let diffAngle = (0, turf_1.angle)(north, start, mid);
        let diffAngleLine = (0, helpers_1.lineString)([north, start, mid]);
        // if (booleanClockwise(diffAngleLine)) {
        //   diffAngle = 360 - diffAngle;
        // }
        angleDiff = diffAngle;
    }
    let baseArea = [start, end, end, start];
    let areaed = (0, helpers_1.polygon)([baseArea]);
    // setup line as an 'area'
    let topArea = (0, turf_1.transformTranslate)(areaed, radius / 2, angleDiff - 90, {
        units: 'meters',
    }).geometry.coordinates[0].slice(0, 2);
    let bottomArea = (0, turf_1.transformTranslate)(areaed, radius / 2, angleDiff + 90, {
        units: 'meters',
    }).geometry.coordinates[0].slice(0, 2);
    let combined = [...topArea, bottomArea[1], bottomArea[0], topArea[0]];
    if (isSmallType) {
        let polygoned = (0, helpers_1.polygon)([combined]);
        let withBuffer = (_a = (0, turf_1.buffer)(polygoned, throwRadius, { units: 'meters' })) === null || _a === void 0 ? void 0 : _a.geometry.coordinates[0];
        if (withBuffer) {
            return EffluentSpreaderHelper_1.EffluentSpreaderHelper.convertTurfToPosition(withBuffer);
        }
    }
    return EffluentSpreaderHelper_1.EffluentSpreaderHelper.convertTurfToPosition(combined);
};
exports.covertLateralPathToArea = covertLateralPathToArea;
const getLinedPositionExtreams = (linePos) => {
    // current implementation does not require it, but for safety
    if (linePos.length < 2) {
        return [
            [0, 0],
            [0, 0],
        ];
    }
    // get center
    const turfedLine = EffluentSpreaderHelper_1.EffluentSpreaderHelper.convertPositionToTurf(linePos);
    // const centerPoint = centroid(polygon([turfedLine])).geometry.coordinates;
    const centerPoint = (0, turf_1.center)((0, helpers_1.points)(turfedLine)).geometry.coordinates;
    const posDist = turfedLine
        .map((pos) => {
        let len = (0, turf_1.distance)(centerPoint, pos);
        return { position: pos, distance: len };
    })
        .sort((a, b) => b.distance - a.distance);
    const firstExtreme = posDist[0].position;
    // recalculate using the extreeme
    const posDist2nd = turfedLine
        .map((pos) => {
        let len = (0, turf_1.distance)(firstExtreme, pos);
        return { position: pos, distance: len };
    })
        .sort((a, b) => b.distance - a.distance);
    const secondExtreme = posDist2nd[0].position;
    // shouldn't be required, but to be safe
    return [firstExtreme, secondExtreme];
};
const covertLateralPathToAreaV2 = (line, throwRadius, radius, basis) => {
    var _a;
    if (throwRadius === undefined || radius === undefined) {
        return undefined;
    }
    if (radius === 0) {
        return (0, exports.convertLineTypePathToArea)(line, throwRadius);
    }
    const [start, end] = getLinedPositionExtreams(line);
    // let start: TurfPosition = [line[0].lng, line[0].lat];
    // let end: TurfPosition = [line[line.length - 1].lng, line[line.length - 1].lat];
    let north = [start[0], start[1] + 1];
    let angleDiff = (0, turf_1.angle)(north, start, end);
    let angleLine = (0, helpers_1.lineString)([north, start, end]);
    // if (booleanClockwise(angleLine)) {
    //   angleDiff = 360 - angleDiff;
    // }
    // same point, a horizontal lines gets created
    // if too close
    let lineDiff = (0, turf_1.distance)(start, end, { units: 'meters' });
    let isSmallType = lineDiff < throwRadius;
    if (isSmallType && basis && basis.path && basis.path.length > 0) {
        // if (lineDiff < 10 && basis && basis.path && basis.path.length > 0) {
        let extreme = EffluentSpreaderHelper_1.EffluentSpreaderHelper.convertPositionToTurf(basis.path);
        let mid = (0, turf_1.midpoint)(extreme[0], extreme[1]).geometry.coordinates;
        let diffAngle = (0, turf_1.angle)(north, start, mid);
        let diffAngleLine = (0, helpers_1.lineString)([north, start, mid]);
        // if (booleanClockwise(diffAngleLine)) {
        //   diffAngle = 360 - diffAngle;
        // }
        angleDiff = diffAngle;
    }
    let baseArea = [start, end, end, start];
    let areaed = (0, helpers_1.polygon)([baseArea]);
    // setup line as an 'area'
    let topArea = (0, turf_1.transformTranslate)(areaed, radius / 2, angleDiff - 90, {
        units: 'meters',
    }).geometry.coordinates[0].slice(0, 2);
    let bottomArea = (0, turf_1.transformTranslate)(areaed, radius / 2, angleDiff + 90, {
        units: 'meters',
    }).geometry.coordinates[0].slice(0, 2);
    let combined = [...topArea, bottomArea[1], bottomArea[0], topArea[0]];
    if (isSmallType) {
        let polygoned = (0, helpers_1.polygon)([combined]);
        let withBuffer = (_a = (0, turf_1.buffer)(polygoned, throwRadius, { units: 'meters' })) === null || _a === void 0 ? void 0 : _a.geometry.coordinates[0];
        if (withBuffer) {
            return EffluentSpreaderHelper_1.EffluentSpreaderHelper.convertTurfToPosition(withBuffer);
        }
    }
    return EffluentSpreaderHelper_1.EffluentSpreaderHelper.convertTurfToPosition(combined);
};
exports.covertLateralPathToAreaV2 = covertLateralPathToAreaV2;
const convertPointTypePathToArea = (line, range, throwRadius) => {
    if (range === undefined || throwRadius === undefined) {
        return undefined;
    }
    let point = EffluentSpreaderHelper_1.EffluentSpreaderHelper.convertPositionToTurf(line);
    if (throwRadius === 0) {
        let pointCoverage = (0, circle_1.default)(point[0], range, { units: 'meters' });
        return EffluentSpreaderHelper_1.EffluentSpreaderHelper.convertTurfToPosition(pointCoverage.geometry.coordinates);
    }
    else {
        // has a radius
        let circleLineBig = (0, circle_1.default)(point[0], throwRadius + range, {
            units: 'meters',
        });
        let circleLineSmall = (0, circle_1.default)(point[0], throwRadius - range, {
            units: 'meters',
        });
        let ring = (0, turf_1.difference)((0, helpers_1.featureCollection)([circleLineBig, circleLineSmall]));
        if ((ring === null || ring === void 0 ? void 0 : ring.geometry.coordinates.length) === 2) {
            let ring1 = EffluentSpreaderHelper_1.EffluentSpreaderHelper.convertTurfToPosition(ring === null || ring === void 0 ? void 0 : ring.geometry.coordinates[0]);
            let ring2 = EffluentSpreaderHelper_1.EffluentSpreaderHelper.convertTurfToPosition(ring === null || ring === void 0 ? void 0 : ring.geometry.coordinates[1]);
            let combined = [...ring1, ...ring2, ring1[0]];
            return combined;
        }
        else if ((ring === null || ring === void 0 ? void 0 : ring.geometry.coordinates.length) === 1) {
            // when there is no hole in the middle
            let pointArea = EffluentSpreaderHelper_1.EffluentSpreaderHelper.convertTurfToPosition(ring === null || ring === void 0 ? void 0 : ring.geometry.coordinates[0]);
            return pointArea;
        }
    }
    return (0, exports.convertLineTypePathToArea)(line, range);
};
exports.convertPointTypePathToArea = convertPointTypePathToArea;
const distanceDifference = (line) => {
    const turfedPostion = EffluentSpreaderHelper_1.EffluentSpreaderHelper.convertPositionToTurf(line, false);
    const startReference = turfedPostion[0];
    const endReference = turfedPostion[turfedPostion.length - 1];
    const distanceFromStart = turfedPostion.map((point) => {
        let lineDiff = (0, turf_1.distance)(point, startReference, { units: 'meters' });
        return lineDiff;
    });
    const distanceFromEnd = turfedPostion.map((point) => {
        let lineDiff = (0, turf_1.distance)(point, endReference, { units: 'meters' });
        return lineDiff;
    });
    console.log('distanceFromStart', distanceFromStart);
    console.log('distanceFromEnd', distanceFromEnd);
    const differenceFromStart = distanceFromStart
        .map((point, i) => {
        if (i !== 0) {
            let lineDiff = Math.abs(point - distanceFromStart[i - 1]);
            return lineDiff;
        }
    })
        .filter((val) => val !== undefined);
    const differenceFromEnd = distanceFromEnd
        .map((point, i) => {
        if (i !== 0) {
            let lineDiff = Math.abs(point - distanceFromEnd[i - 1]);
            return lineDiff;
        }
    })
        .filter((val) => val !== undefined);
    console.log('differenceFromStart', differenceFromStart);
    console.log('differenceFromEnd', differenceFromEnd);
    // less than one start?
    return [distanceFromStart, distanceFromEnd];
};
exports.distanceDifference = distanceDifference;
